import styled from '@emotion/styled';

export const Headline = styled.h2`
  text-align: center;
`;

export const BodyText = styled.p`
  text-align: center;
`;
